import React, { useContext } from 'react'
import SignupContext from 'modules/react/signup/SignupContext'
import RightContentEmployee from 'modules/react/signup/RightContentEmployee'

export default function Step1RightContent () {

  const { course } = useContext(SignupContext)

  return (
    <>
      <RightContentEmployee/>
    </>
  )
}